module.exports = __webpack_public_path__ + "static/media/Loading.63c01126.svg";